import React, { useState } from "react";
import PropTypes from "prop-types";
import "./Designation.css";
import { useDesignations } from "Hooks/AdminHooks/Organization/useDesignation";
import { DesignationLevelEnum, DesignaitonEnumLabel } from "Constants/Enums/DesignationLevelEnum";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { ApartmentOutlined, TeamOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { object } from "joi";
import { toast } from "react-toastify";

const DesignationHierarchy = () => {
  const {
    stats,
    getByLevel,
    selectedStatus,
    setSelectedStatus,
    loading,
    rankOptions,
    rankLoading,
    fetchRankOptions,
    createDesignation,
    fetchData,
  } = useDesignations();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    rank: "",
    shiftRanksDown: false,
    isSingleSeat: false,
    level: "",
  });

  const handleLevelChange = async (e) => {
    const level = e.target.value;
    setFormData((prev) => ({
      ...prev,
      level: level !== "" ? Number(level) : "",
      rank: "",
    }));

    if (level !== "") {
      fetchRankOptions(Number(level));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const paylaod = {
      name: formData.name,
      description: formData.description,
      rank: Number(formData.rank),
      shiftRanksDown: formData.shiftRanksDown,
      isSingleSeat: formData.isSingleSeat,
      level: Number(formData.level),
    };

    try {
      await createDesignation(paylaod);
      toast.success("Designation Created succesfuly");
      fetchData();
      setFormData({
        name: "",
        description: "",
        rank: "",
        shiftRanksDown: false,
        isSingleSeat: false,
        level: "",
      });
      setShowForm(false);
    } catch (error) {
      console.error("eroro");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-4">
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="text-main fw-bold mb-1">Designation Hierarchy</h2>
            <p className="text-secondary">Manage organizational authority levels.</p>
          </div>

          <div>
            <Button className="btn-primary" onClick={() => setShowForm(true)}>
              Add Designation
            </Button>
          </div>
        </div>

        {showForm && (
          <div className="card shadow-sm border-0 rounded-4 mb-4">
            <div className="card-body">
              <h5 className="fw-bold mb-3">Create New Designation</h5>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-4 ">
                    <label className="form-label small mb-1">Designation Name</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Please enter designation name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </div>

                  <div className="col-md-4 ">
                    <label className="form-label small mb-1">Level</label>
                    <select
                      className="form-select form-select-sm"
                      value={formData.level}
                      onChange={handleLevelChange}
                    >
                      <option value="" className="small">
                        Select Level
                      </option>
                      {Object.values(DesignationLevelEnum).map((levelValue) => (
                        <option key={levelValue} value={levelValue}>
                          {DesignaitonEnumLabel[levelValue]}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label small mb-1">Rank</label>
                    <select
                      className="form-select form-select-sm"
                      value={formData.rank}
                      disabled={!formData.level === "" || rankLoading}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          rank: Number(e.target.value),
                        })
                      }
                    >
                      <option value="" className="small">
                        Select Rank
                      </option>
                      {rankOptions?.map((rank) => (
                        <option key={rank} value={rank}>
                          Rank {rank}
                        </option>
                      ))}
                    </select>
                    {rankLoading && <small className="text-muted">Loading Ranks...</small>}
                  </div>
                </div>

                <div className="col-12 d-flex align-items-center gap-4 mt-2">
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={formData.shiftRanksDown}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          shiftRanksDown: e.target.checked,
                        })
                      }
                    />
                    <label className="mt-2 small">Shift lower ranks down</label>
                  </div>

                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={formData.isSingleSeat}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          isSingleSeat: e.target.checked,
                        })
                      }
                    />
                    <label className="mt-2 small">Single Seat Only</label>
                  </div>
                </div>

                <div className="col-12 mt-2">
                  <label className="form-label small mb-1">Description</label>
                  <textarea
                    className="form-control form-control-sm"
                    rows="2"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        description: e.target.value,
                      })
                    }
                  />
                </div>

                {/* ===== BUTTONS ===== */}
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <Button size="small" onClick={() => setShowForm(false)}>
                    Cancel
                  </Button>

                  <Button size="small" className="btn-primary" htmlType="submit">
                    Save
                  </Button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* STATS */}
        <div className="row g-3 mb-4">
          <StatCard
            title="Total Designations"
            value={stats.total}
            subText={`${stats.active} active`}
            icon={ApartmentOutlined} // Updated icon reference
            color="primary"
          />

          <StatCard
            title="Total Employees"
            value={stats.totalEmployees}
            subText="Across all roles"
            icon={TeamOutlined} // Component, not a string
            color="success"
          />

          {/* <StatCard
    title="Active Roles"
    value={stats.active}
    subText="Currently active"
    icon={CheckCircleOutlined}
    color="info"
  />

  <StatCard
    title="Inactive Roles"
    value={stats.total - stats.active}
    subText="Currently inactive"
    icon={CloseCircleOutlined}
    color="danger"
  /> */}
        </div>

        {/* HIERARCHY */}
        <div className="card shadow-sm border-0 mb-4">
         <div className="card-header bg-white py-3">
    {/* UPDATED: Added text-main to match your brand #206d1a */}
    <h5 className="fw-bold mb-0 text-main">Authority Hierarchy</h5>
  </div>

          <div className="card-body">
            {/* STATUS FILTER */}
            <div className="d-flex align-items-center gap-3 mb-5">
              <span className="text-muted fw-bold small text-uppercase">Status</span>
              <div className="btn-group bg-light p-1 rounded">
                {["All", "Active", "Inactive"].map((status) => (
                  <button
                    key={status}
                    className={`btn btn-sm px-3 border-0 rounded ${
                      selectedStatus === status
                        ? "bg-white shadow-sm fw-bold text-primary"
                        : "text-muted"
                    }`}
                    onClick={() => setSelectedStatus(status)}
                  >
                    {status}
                  </button>
                ))}
              </div>
            </div>

            {loading ? (
              <div className="text-center py-5">Loading...</div>
            ) : (
              <>
                <HierarchyLevel
                  title="Corporate Leadership"
                  items={getByLevel(DesignationLevelEnum.Executive)}
                />

                <HierarchyLevel
                  title="Middle Management"
                  items={getByLevel(DesignationLevelEnum.Management)}
                  className="mt-5"
                />

                <HierarchyLevel
                  title="Individual Contributors"
                  items={getByLevel(DesignationLevelEnum.IndividualContributor)}
                  className="mt-5"
                  isSmall
                />
              </>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

const HierarchyLevel = ({ title, items, className = "", isSmall = false }) => (
  <div className={`hierarchy-level ${className}`}>
    <h6
      className="hierarchy-level-title text-muted mb-4 fw-bold text-uppercase"
      style={{ fontSize: "0.75rem", letterSpacing: "1px" }}
    >
      {title}
    </h6>

    <div className="row g-3">
      {items.length > 0 ? (
        items.map((desig) => (
          <div key={desig.id} className={isSmall ? "col-lg-2 col-md-4 col-6" : "col-lg-4 col-md-6"}>
            <div
              className={`hierarchy-card h-100 ${!desig.isActive ? "hierarchy-card-inactive" : ""}`}
            >
              {/* HEADER: Contains Title and Status */}
              <div className="hierarchy-card-header d-flex justify-content-between align-items-start p-3">
                <div>
                  <h6 className="fw-bold mb-1 text-dark small">{desig.name}</h6>
                  <div className="text-muted extra-small">Rank: {desig.rank}</div>
                </div>
                <span className={`badge ${desig.isActive ? "bg-success" : "bg-secondary"}`}>
                  {desig.isActive ? "Active" : "Inactive"}
                </span>
              </div>

              {/* BODY: Added this wrapper to fix your spacing issue */}
              <div className="hierarchy-card-body p-3">
  {/* Description */}
  {desig.description && (
    <div className="mb-2">
      <div
        className="text-muted small"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {desig.description}
      </div>
    </div>
  )}

  {/* Employees Section */}
  <div className="mb-3">
    <div className="text-muted small">Employees</div>
    <div className="fw-bold h5 mb-0">
      {desig.employeeCount || 0}
    </div>
  </div>

  {/* Footer */}
  <div className="d-flex justify-content-between align-items-center pt-2 border-top">
    <div className="text-muted extra-small">
      {desig.publicId}
    </div>

    {desig.isSingleSeat && (
      <div className="text-primary extra-small fw-bold">
        Single
      </div>
    )}
  </div>
</div>
            </div>
          </div>
        ))
      ) : (
        <div className="col-12 text-center py-4 text-muted">No roles defined.</div>
      )}
    </div>
  </div>
);

HierarchyLevel.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  className: PropTypes.string,
  isSmall: PropTypes.bool,
};

const StatCard = ({ title, value, subText, icon: Icon, color }) => {
  const colorMap = {
    primary: "#0d6efd",
    success: "#198754",
    info: "#0dcaf0",
    warning: "#ffc107",
  };

  const activeColor = colorMap[color] || colorMap.primary;

  return (
    <div className="col-xl-3 col-md-6 mb-3">
      <div
        className="card stat-card-tight shadow-sm border-0 "
        style={{ borderTop: `4px solid ${activeColor}`, borderRadius: "14px" }} // Increased to 4px for that solid look
      >
        <div className="card-body p-2 px-3">
          {" "}
          {/* Extra tight padding: 0.5rem top/bottom, 1rem sides */}
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <span className="text-muted d-block extra-small-label">{title}</span>
              <h2 className="text-main fw-bold mb-1">{value}</h2>
            </div>
            <Icon style={{ fontSize: "1.8rem", color: activeColor }} />
          </div>
          <div className="mt-1">
            <small className="text-muted tiny-text">{subText}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

// Update Prop types to handle Icon as a component
StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subText: PropTypes.string,
  icon: PropTypes.elementType, // Changed from string to elementType
  color: PropTypes.string,
};

export default DesignationHierarchy;
